import React from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";

import { Breadcrumb, Breadcrumbs } from "@performyard/py-components";

import { useIsNewNavigation } from "../../api/hooks/defs/navigation";

import { parseChangeFieldsOrigin } from "../../utils/changeFieldsBreadcrumbs";

const ChangeFieldsBreadcrumbs = () => {
	const location = useLocation();
	const isNewNav = useIsNewNavigation();
	const mount = typeof document !== "undefined" ? document.getElementById("change-fields-breadcrumbs") : null;

	if (!isNewNav || !mount) return null;

	const { from, label } = parseChangeFieldsOrigin(location.search);

	const items: Breadcrumb[] = [
		{ pageId: "breadcrumb-change-fields-origin", name: label, href: from, forceHardReload: true },
		{ pageId: "breadcrumb-change-fields-current", name: "Change Fields", href: location.pathname },
	];

	return createPortal(
		<div style={{ padding: "16px 24px 0" }}>
			<Breadcrumbs items={items} />
		</div>,
		mount
	);
};

export default ChangeFieldsBreadcrumbs;
